import { render, staticRenderFns } from "./ws4-restricted-warning.vue?vue&type=template&id=61b4ff3a"
import script from "./ws4-restricted-warning.vue?vue&type=script&lang=js"
export * from "./ws4-restricted-warning.vue?vue&type=script&lang=js"
import style0 from "./ws4-restricted-warning.vue?vue&type=style&index=0&id=61b4ff3a&prod&lang=less&rel=stylesheet%2Fless"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports